import React, { Component } from "react";
import { observer } from "mobx-react";
import {
    StylesProvider,
    FormControlLabel,
    Checkbox,
    Grid,
    Button,
    MenuItem,
    Select,
    FormControl,
    InputLabel
} from "@material-ui/core";

import Abstract from "../Abstract";
import Store from "./Store";
import DateInput from "../../../common/components/input/Date";
import autoBind from "auto-bind";

class DateFilter extends Abstract {
    constructor(...args) {
        super(...args);
        console.log(args)
        this.store = new Store(...args);

        this.props.onComponentLoaded(this.store);
        autoBind(this);
    }

    setModel() {

    }

    handleChange(e) {
        const { selectedOptions } = this.store

        if (e.target.checked) {
            selectedOptions.add(e.target.value)
        } else {
            selectedOptions.delete(e.target.value)
        }
    }

    handleClear(e) {
        this.store.startDate = null;
        this.store.endDate = null;        
        this.store.selectedOptions.clear();
        this.handleSubmit();
    }

    handleYearStartsFromChange(e) {
        this.store.yearStartsFrom = e.target.value;
    }

    handleStartDateChange(value) {
        if (value != "Invalid Date" && !isNaN(value.getDate())) {
            const modifiedValue = new Date(value.getFullYear(), value.getMonth(), value.getDate(), 0, 0, 0);
            this.store.startDate = modifiedValue;
        } else {
            this.store.startDate = "";
        }
    }

    handleEndDateChange(value) {
        if (value != "Invalid Date" && !isNaN(value.getDate())) {
            const modifiedValue = new Date(value.getFullYear(), value.getMonth(), value.getDate(), 23, 59, 59);
            this.store.endDate = modifiedValue;
        } else {
            this.store.endDate = "";
        }
    }

    handleSubmit(e) {
        const {
            selectedOptions,
            yearStartsFrom,
            startDate,
            endDate,
            searchQuery
        } = this.store;

        if (!searchQuery) {
            return this.props.onChange();
        }

        this.props.onChange({
            filterType: "date",
            selectedOptions,
            yearStartsFrom,
            startDate,
            endDate,
            valueString: searchQuery
        });
    }

    render() {
        const {
            checkboxOptions,
            selectedOptions,
            yearNames,
            yearStartsFrom,
            startDate,
            endDate,
            checkboxOptionsGroups
        } = this.store;
        const borderTopStyle = { borderTop: "1px solid #cfcfcf" };
        const isDateTime =
          this.store.agGridProps.colDef?.cellRendererParams?.columnTypeId ===
          "4"
            ? false
            : true;
        const dateFormat = this.store.agGridProps.colDef?.cellRendererParams
          ?.columnOptions["format"];        
        return (
            <Grid container style={{ width: 300, padding: 10 }} >
                {
                    checkboxOptionsGroups.map((checkboxOptions, index) => (
                        <Grid item container xs={12} style={index != 0 ? borderTopStyle : {}}>
                            {checkboxOptions.map(checkboxOption => {
                                const key = checkboxOption.value;
                                const name = checkboxOption.name;

                                return (
                                    <Grid item xs={6} key={key}>
                                        <FormControlLabel
                                            control={<Checkbox size="small" color="primary" value={key} checked={selectedOptions.has(key)} onChange={this.handleChange} name="" />}
                                            label={name}
                                        />
                                    </Grid>
                                )
                            })}
                        </Grid>
                    ))

                }

                {selectedOptions.has("G") &&
                    <Grid
                        item
                        xs={12}
                        style={{ padding: "10px 0px", ...borderTopStyle }}
                    >
                        <Grid
                            item
                            container
                            justify="space-between"
                            alignItems="center"
                        >
                            <span>Start Date:</span>&nbsp;&nbsp;
                            <DateInput 
                                value={startDate} 
                                isDateTime={false}
                                format={dateFormat}
                                underLine={true}
                                styledPopper={true}
                                onChange={this.handleStartDateChange} />
                        </Grid>
                        <Grid
                            item
                            container
                            justify="space-between"
                            alignItems="center"
                        >
                            <span>End Date:</span>&nbsp;&nbsp;
                            <DateInput 
                                value={endDate} 
                                isDateTime={false}
                                format={dateFormat}
                                underLine={true}
                                styledPopper={true}
                                onChange={this.handleEndDateChange} />
                        </Grid>
                    </Grid>
                }
                {selectedOptions.has("E") &&
                    <Grid
                        item
                        container
                        alignItems="center"
                        style={{ padding: "10px 0px", ...borderTopStyle }}
                    >
                        <span>Year Starts From: </span>
                    &nbsp;&nbsp;
                    <Select
                            value={yearStartsFrom}
                            onChange={this.handleYearStartsFromChange}
                            MenuProps={{
                                className: "ag-custom-component-popup"
                            }}
                        >
                            {yearNames.map(year => <MenuItem value={year.name}>{year.name}</MenuItem>)}
                        </Select>
                    </Grid>
                }
                <Grid item xs={12}>
                    <Button variant="contained" color="primary" onClick={this.handleSubmit}>
                        Ok
                    </Button>
                    <Button color="primary" onClick={this.handleClear}>
                        Clear
                    </Button>
                </Grid>
            </Grid>
        )
    }
}

export default observer(DateFilter); 